import JSONFeed from 'src/status/reducers/JSONFeed'
export default {
  JSONFeed,
}
